import { render, staticRenderFns } from "./edit.internal_projects.page.vue?vue&type=template&id=4a037024&"
import script from "./edit.internal_projects.page.vue?vue&type=script&lang=js&"
export * from "./edit.internal_projects.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports